import { CapacityGetNtcRequestStoreModel, CapacitySubmitNtcRequestStoreModel } from './capacity.store-model';

export const mapCapacitySubmitNtcRequestStoreModelToCapacityGetNtcRequestStoreModel = (
  request: CapacitySubmitNtcRequestStoreModel
): CapacityGetNtcRequestStoreModel => {
  return {
    deliveryDayDateTime: request.deliveryDayDateTime,
    timescale: request.timescale,
    originator: request.originator,
    borderDirection: request.borderDirection,
  };
};
